import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, CustomerInfo, CustomerType, User, CampaignInfo } from 't4core';
import { VerifyAccountComponent } from '../../../MyPage/Components/verify-account/verify-account.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AppSettingsService } from 't4-app-integration';
import { PinCodeDialog } from '../../Dialogs/pin-code-dialog/pin-code-dialog';
import { UntypedFormControl } from '@angular/forms';
import { NavigationService } from 'app-components';
import moment from 'moment';

@Component({
  selector: 'app-my-campaigns',
  templateUrl: './my-campaigns.html',
  styleUrls: ['./my-campaigns.css'],
  standalone: false
})

export class CampaignComponent extends PageBase implements OnInit {

  private _campaigns: CampaignInfo[];
  public currentTime: moment.Moment = moment();

  public activeCampaigns: ExtendedCampaignInfo[] = [];
  public expiredCampaigns: ExtendedCampaignInfo[] = [];

  public isLoading: boolean = false;

  public currentTab = 0;

  constructor(
    el: ElementRef,
    public appSettings: AppSettingsService,
    private navigationService: NavigationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(el);
  }

  async ngOnInit() {
    this.isLoading = true;
    var token = this.UI.beginLoading("Intellitrailer.MyPage.MyCampaigns.msgLoading", "Getting offers", null);
    await this.loadCampaigns();

    this.UI.loaderCompleted(token);
    this.isLoading = false;
  }

  async loadCampaigns(): Promise<void> {
    this._campaigns = await this.Api.get<CampaignInfo[]>("/Campaign/GetUserCampaigns");
    this._campaigns.forEach(campaign => {
      // Create an ExtendedCampaignInfo object with the default showTextFully value
      const extendedCampaign: ExtendedCampaignInfo = {
        ...campaign,
        showTextFully: false // Default value for showTextFully
      };

      // If the Campaign has ended or is used, move it to expired.
      if (extendedCampaign.ValidThrough < this.currentTime || extendedCampaign.IsUsed) {
        this.expiredCampaigns.push(extendedCampaign);
      }
      // If the campaign is still active, put it as Active.
      else if (extendedCampaign.ValidThrough > this.currentTime && !extendedCampaign.IsUsed) {
        this.activeCampaigns.push(extendedCampaign);
      }
    });
  }


  public async activate(campaign: CampaignInfo) {
    var x = await this.UI.confirm("Intellitrailer.MyPage.CampaignCard.ConfirmActivation.Headline", "Confirm Activation", "Intellitrailer.MyPage.CampaignCard.ConfirmActivation.Message2", "Are you sure that you want to activate it?  Be prepared to display it to staff right away, as it cannot be activated more than once.");
    if (x) {
      console.log(x);
      this.navigationService.executeCommand("Details", { discountCode: campaign.DiscountCode });



    }
  }
  public toggleTab(number) {
    this.currentTab = number;
  }


  toggleText(campaign: ExtendedCampaignInfo) {
    console.log(campaign);
    campaign.showTextFully = !campaign.showTextFully;
    console.log(campaign);
    this.changeDetectorRef.detectChanges();
  }


}


export type ExtendedCampaignInfo = CampaignInfo & {
  showTextFully: boolean;
};
